import type { AudioPluginEditorConfig } from '@wix/ricos';
import React from 'react';

import { mockImageUploadFunc } from './file-selection-mock';
import { testAudio, testImages } from './mock-data';
import { MockModal } from './mock-modal';
import type { OpenModalFn } from './mock-modal-context';

type AudioUploadFunc = Exclude<AudioPluginEditorConfig['handleFileSelection'], undefined>;

export const mockAudioUploadWithModal =
  (openModal: OpenModalFn): AudioUploadFunc =>
  (updateEntity, _removeEntity, fromSettings, componentData) => {
    // for uploading cover image from the settings modal:
    if (fromSettings) {
      return mockImageUploadFunc(
        undefined,
        false,
        ({ data }) => {
          const coverImage = data?.[0] || testImages[0];
          updateEntity({ data: coverImage as any });
        },
        undefined,
        componentData
      );
    }

    const items = testAudio.map(({ name }) => ({ label: name }));
    openModal(close => (
      <MockModal
        close={close}
        onConfirm={({ selected }) => {
          setTimeout(() => updateEntity({ data: testAudio[selected[0]] }), 500);
        }}
        items={items}
      />
    ));
  };
